import { useAppStore } from '@/store/modules/app';

// C++ 主动调 JS 的通道只有 window.WorkAiSetData 一个全局函数（见 WinContext.WorkAiSetData），
// 直接注册是覆盖式的——后注册的会把先注册的顶掉。这里统一接管：
// 总回调只注册一次，收到消息后分发给所有订阅者，各业务按 msgType 自行过滤。

type CefEventHandler = (msgType: string, msg: any) => void;

const handlers = new Set<CefEventHandler>();
let registered = false;

// 客户端桥（MyWin）由启动引导初始化，早于它订阅时先不注册，等下一次订阅再试
function ensureRegistered() {
    if (registered) return;

    const appStore = useAppStore();
    if (!appStore.MyWin) return;

    appStore.MyWin.WorkAiSetData((msgType: any, msg: any) => {
        // 一个订阅者抛错不能连累其它订阅者
        handlers.forEach((handler) => {
            try {
                handler(msgType, msg);
            } catch (err) {
                console.error('[CEF事件] 处理失败', msgType, err);
            }
        });
    });

    registered = true;
}

/**
 * 订阅 C++ 推送的事件
 * @param handler 收到任意事件都会调用，自行按 msgType 过滤
 * @returns 取消订阅
 */
export function onCefEvent(handler: CefEventHandler) {
    handlers.add(handler);
    ensureRegistered();

    return () => {
        handlers.delete(handler);
    };
}
